import { OptionKey } from '@common-fe/common-fe';

import { ServiceType } from './EligibleServices.constants';

export enum CategoryType {
  ADOPTION = 'ADOPTION',
  DENTAL = 'DENTAL',
  DEPENDENT_CARE = 'DEPENDENT_CARE',
  MEDICAL = 'MEDICAL',
  PARKING = 'PARKING',
  PREMIUM = 'PREMIUM',
  PHARMACY = 'PHARMACY',
  TRANSIT = 'TRANSIT',
  VISION = 'VISION',
  DEFAULT = 'DEFAULT',
  WELLNESS = 'WELLNESS',
  TRAVEL = 'TRAVEL',
}

export interface ServiceDto {
  id: number;
  name: string;
  description: string | null;
  service_type?: string;
}

export interface CategoryDto {
  id: number;
  category: string;
  services: ServiceDto[];
}

export interface Service {
  id: string;
  name: string;
  description: string | null;
  type: string;
  serviceType: ServiceType;
}

export interface Category {
  id: string;
  category: string;
  servicesTotal: number;
  services: Service[];
}

export interface SearchParams {
  name?: string;
  sort?: string;
  categories?: OptionKey[];
  types?: OptionKey[];
}
